<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Import</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Import data from json file into a Firestore collection
    </ion-list-header>

    <ion-radio-group>
        @for (option of importOptions; track $index) {
  <ion-item>
            <ion-label class="ion-text-wrap">
                <span class="line1">Action: {{option.description}}</span><br />
                <span class="line2">Data Files: {{option.dataFiles}}</span><br />
            </ion-label>
            <ion-radio (click)="onChooseImportOptionClick(option)"></ion-radio>
        </ion-item>
}
    </ion-radio-group>
<!-- 
    @if (importInProgress) {
  <ion-item-divider color="tertiary">Progress</ion-item-divider>
}
    <ion-item>
        <ion-label class="ion-text-wrap">
            <span class="line1">{{currentItem.index}}</span><br />
            <span class="line2">{{currentItem.data}}</span>
        </ion-label>
    </ion-item> -->

</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="startImportButton" [disabled]="importInProgress" color="primary" expand="full" (click)="onStartImportClick()">
            Start Import
        </ion-button>
    </ion-toolbar>
</ion-footer>